<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter-number">ACKNOWLEDGEMENTS</h2>
<p class="flush-left">I’d like to thank Joan Hess for the many mutual plot sessions over a semi-friendly game of backgammon; my long-time reader and even longer-time daughter, Evin Cooper; my stalwart agent, Vicky Bijur, for her input and support; my editor, Sara Porter, for her advice and counsel, and a special thank you to Jan Grape, long-time reader and friend, who invited me to swim with the dolphins.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?a445b70c